import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { formatAmountCurrency } from '../../utils';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import LinkButtonComponent from '../button/LinkButtonComponent';

import './ErrorEbonModalStyle.scss';

const EbonErrorModal = ({ modalData, merchantCardPath, partnerName, i18n }) => {
    return (
        <div id="ebon-error-modal-data">
            <h1>{i18n.MODALDATA.TITLE}</h1>

            <p className="recapText">{i18n.MODALDATA.TEXT_1}</p>

            <div className="wrapper">
                <h3>{`${i18n.RECAPITULATIF}`}</h3>

                {modalData.map((ebons, id) => (
                    <div key={id} className="recapUnavailable">
                        <p>
                            {convertHtmlToReactDomWithParams(
                                i18n.BON_ACHAT_LIGNE,
                                partnerName,
                                formatAmountCurrency(ebons.facialValue)
                            )}
                        </p>
                        <div style={{ minWidth: '100px' }}>
                            <span>
                                {ebons.quantityLocked}/{ebons.quantityQuery}{' '}
                            </span>
                            <span>{i18n.MODALDATA.TEXT_2}</span>
                            <span style={{ justifyContent: 'flex-end', flex: 2 }}>
                                {formatAmountCurrency(ebons.quantityLocked * ebons.facialValue)}
                            </span>
                        </div>
                    </div>
                ))}

                <LinkButtonComponent
                    to={merchantCardPath}
                    color="main"
                    title={i18n.MODALDATA.BUTTON}
                    text={i18n.MODALDATA.BUTTON}
                />
            </div>
        </div>
    );
};

EbonErrorModal.propTypes = {
    modalData: PropTypes.object,
    merchantCardPath: PropTypes.string,
    partnerName: PropTypes.string
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON
    };
};

export default connect(mapStateToProps)(EbonErrorModal);



// WEBPACK FOOTER //
// ./src/components/funnel/EbonErrorModal.js